import React from 'react';
import PropTypes from 'prop-types';

//components
import FormLabel from '../Label';
import { SingleMultipleLayout } from '../SingleMultipleLayout';
//styles
import { Input, RadioButtonWrapper, RadioBtn } from './index.styled';

const RadioButton = ({
  name,
  description,
  setFieldValue,
  label,
  value,
  checked,
  disabled,
  multiple,
  isRequired,
}) => {
  return (
    <SingleMultipleLayout multiple={multiple}>
      {label && <FormLabel label={label} name={name} isRequired={isRequired} />}
      <RadioButtonWrapper disabled={disabled}>
        {description}
        <Input
          disabled={disabled}
          onChange={() => setFieldValue(name, value)}
          checked={checked}
          type="radio"
          name={name}
        />
        <RadioBtn disabled={disabled} />
      </RadioButtonWrapper>
    </SingleMultipleLayout>
  );
};

RadioButton.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool,
};

export default RadioButton;
